export default function getStripeAccountName(seller = {}) {
  return seller.paymentGateways?.stripe?.dashboardDisplayName;
}
